import { render } from "./CurrencyDropdown.vue?vue&type=template&id=51b33632&scoped=true"
import script from "./CurrencyDropdown.vue?vue&type=script&lang=js"
export * from "./CurrencyDropdown.vue?vue&type=script&lang=js"

import "./CurrencyDropdown.vue?vue&type=style&index=0&id=51b33632&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b33632"]])

export default __exports__